export default "__VITE_ASSET__rBv$zLAS__"